<template>
  <div class="addressList">
    <!--新增收货地址-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="addAddressShow"
               position="bottom"
               :style="{ height: '100%' }">
      <div class="addAddress_pop">
        <div class="addAddress_pop_main">
          <van-field v-model="addAddress.areaName" label="自提区域" placeholder="点击选择自提区域"
                     readonly @click="addAreaShow = true" />
          <van-field v-model="addAddress.addr" label="详细地址" placeholder="请填写您的详细地址" />
        </div>
        <div class="addAddress_pop_btn">
          <span class="b_red white bor_red" @click="addressSave">确定</span>
          <span class="bor_ddd b_white gray_3 " @click="backTo">返回</span>
        </div>
      </div>
    </van-popup>
    <!--新增收货地址地区选择-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="addAreaShow"
               :safe-area-inset-bottom="true"
               closeable
               round
               position="bottom">
      <van-cascader
        v-model="addAddress.areaId"
        title="请选择所在地区"
        :options="options"
        @change="areaChange"
        @finish="areaSelect"
        :field-names="fieldNames"
        @close="addAreaShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Toast } from "vant";
import common from "@/assets/js/common";
// import cityData3 from '@/assets/js/city.data-3';

export default {
  data() {
    return {
      fieldNames: {
        text: "name",
        value: "id",
        children: "children"
      },
      options: [],
      areaIndex: [],
      addAddressShow: true, // 是否显示新增收货地址
      addAreaShow: false, // 是否显示新增收货地址省市区选择
      disabledList: [ // 超出范围地址
      ],
      addressInfo: {}, // 编辑地址的地址信息
      // areaList: cityData, // 省市县的数据
      areaList: {}, // 省市县的数据
      searchResult: [], // 搜索详细地址联想的地址
      chosenAddressId: this.selectDeliveryId,
      addressList: [],
      addAddress: {
        deliveryId: null,
        areaId: "",
        addr: "",
        areaName: "",
        type: 2
      }
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    if (!common.isLogin(this.userInfo.id)) {
      return;
    }
    this.getAreas(0, 0);
  },
  methods: {
    // 获取省市县 index 0-省 1-市 2-县 3-街道
    getAreas(areaId, index) {
      this.$store.dispatch("app/getAreas", {
        parentId: areaId
      }).then((data) => {
        const list = data.map((item) => {
          const { id, end, name } = item;
          if (end) {
            return { id, end, name };
          }
          return {
            id, end, name, children: []
          };
        });
        if (index === 0) {
          this.options = list;
        } else if (index === 1) {
          this.options.forEach((item) => {
            if (item.id === areaId) {
              item.children = list;
            }
          });
        } else if (index === 2) {
          const parentId = this.areaIndex[0];
          this.options.forEach((item) => {
            if (item.id === parentId) {
              item.children.forEach((item1) => {
                if (item1.id === areaId) {
                  item1.children = list;
                }
              });
            }
          });
        } else if (index === 3) {
          const parentId = this.areaIndex[0];
          const cityId = this.areaIndex[1];
          this.options.forEach((item) => {
            if (item.id === parentId) {
              item.children.forEach((item1) => {
                if (item1.id === cityId) {
                  item1.children.forEach((item2) => {
                    if (item2.id === areaId) {
                      item2.children = list;
                    }
                  });
                }
              });
            }
          });
        }
      });
    },
    // 选择省市县的change事件
    areaChange(event) {
      console.log("change", event);
      const { value, tabIndex, selectedOptions } = event;
      const { end, children } = selectedOptions[tabIndex];
      if (tabIndex === 0) {
        this.areaIndex = [value, "", ""];
      } else if (tabIndex === 1) {
        const province = this.areaIndex[0];
        this.areaIndex = [province, value, ""];
      } else if (tabIndex === 2) {
        this.areaIndex[2] = value;
      }
      // end 是否结束查询 如果有子级元素结束查询
      if (end || children.length) {
        return;
      }
      const index = tabIndex + 1;
      this.getAreas(value, index);
    },
    // 新增地址确定
    addressSave() {
      const {
        addr, areaId
      } = this.addAddress;
      if (!addr || !areaId) {
        Toast("请补全增加信息");
        return;
      }
      const url = "addr/addr/addSellerAddr";
      this.$store.dispatch(url,
        this.$qs.stringify(
          {
            ...this.addAddress
          },
        )).then((data) => {
        Toast({
          message: data.message,
          position: "bottom"
        });
        window.location.href = `${process.env.VUE_APP_APP}mob/mj/addr/queryAllMobAddr.do?type=2`;
      });
    },
    areaSelect(item) {
      this.addAreaShow = false;
      const areaName = [];
      // eslint-disable-next-line no-unused-vars
      let areaAxis = "";
      item.selectedOptions.forEach((area) => {
        areaName.push(area.name);
        areaAxis += `$${area.id}`;
      });
      this.$set(this.addAddress, "areaName", areaName.join(""));
      this.$set(this.addAddress, "areaAxis", areaAxis);
      console.info(this.addAddress);
    },
    backTo() {
      this.addAddressShow = false;
      window.location.href = `${process.env.VUE_APP_APP}mob/mj/addr/queryAllMobAddr.do?type=2`;
    }
  }
};
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
